import typeOf from '../../helpers/typeOf';
import {
    metrics
} from './config';


class Helpers {
    getParams(keys) {
        if (typeOf.isObject(keys)) {
            return metrics[keys.metricKey][keys.key] || {};
        }

        return metrics[keys] || {};
    }
}

export default Helpers;
